var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInKnockout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LinkedIn-knockout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn-knockout",
    stroke: "none",
    strokeWidth: 1,
    fill: "#00265f",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn",
    transform: "translate(1.000000, 1.009000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.244,14.622 C29.244,22.697 22.698,29.243 14.622,29.243 C6.547,29.243 0,22.697 0,14.622 C0,6.546 6.547,0 14.622,0 C22.698,0 29.244,6.546 29.244,14.622",
    id: "Fill-105",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.322,11.899 L11.322,20.995 L8.49,20.995 L8.49,11.899 L11.322,11.899 Z M18.523,11.673 C21.386,11.673 21.913,13.556 21.913,16.006 L21.913,20.995 L19.088,20.995 L19.0870032,16.3239326 C19.0764615,15.3162604 18.9564615,14.16 17.618,14.16 C16.147,14.16 15.922,15.31 15.922,16.495 L15.922,20.995 L13.096,20.995 L13.096,11.899 L15.808,11.899 L15.808,13.143 L15.845,13.143 C16.224,12.427 17.146,11.673 18.523,11.673 Z M9.907,7.378 C10.812,7.378 11.545,8.113 11.545,9.017 C11.545,9.921 10.812,10.657 9.907,10.657 C8.998,10.657 8.265,9.921 8.265,9.017 C8.265,8.113 8.998,7.378 9.907,7.378 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInKnockout);
export default __webpack_public_path__ + "static/media/LinkedIn-knockout.4bf23d1e89256dcd029322f7c6e7ca42.svg";
export { ForwardRef as ReactComponent };